import { Menu, Transition } from "@headlessui/react";
import React from "react";
import { Fragment, useEffect, useRef, useState } from "react";
import { FaAngleDown, FaList, FaUserAlt } from "react-icons/fa";
import { useSelector } from "react-redux";
import DatePicker from "react-datepicker";
import { MdDateRange } from "react-icons/md";
import { FaRegFileAlt } from "react-icons/fa";


export default (props: any) => {
 

  return (
    <>
      <div className="my-2">
        <p className="text-xs mb-2 ">{props.title}</p>
        <div className=" px-4 py-1  flex text-sm bg-white w-full  rounded-[8px]  border-2 border-gray-200 items-center">
      <div className=" p-1 w-[50%] border border-gray-300  rounded-[8px] text-textbg font-semibold text-xs inline "> 

      <FaRegFileAlt className="inline " size={20}/> Select File
      </div>
     
         
        </div>
      </div>
    </>
  );
};
